module.exports = __webpack_public_path__ + "img/logout.e98f71f4.svg";